import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_intro = _resolveComponent("intro")!
  const _component_work = _resolveComponent("work")!
  const _component_experience = _resolveComponent("experience")!
  const _component_about_me = _resolveComponent("about-me")!
  const _component_get_in_touch = _resolveComponent("get-in-touch")!
  const _component_footer_section = _resolveComponent("footer-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_intro),
    _createVNode(_component_work),
    _createVNode(_component_experience),
    _createVNode(_component_about_me),
    _createVNode(_component_get_in_touch),
    _createVNode(_component_footer_section)
  ]))
}